<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-修改
    -->
  <el-dialog
    title="修改分类"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <!-- <el-form-item label="所属分类" :label-width="formLabelWidth">
        <el-select v-model="form.parent_id">
          <el-option label="顶级分类" :value="0"></el-option>
          <el-option :value="cat.categoryId" :label="cat.name" :key="cat.categoryId" v-for="cat in editform.catList"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="分类名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="分类图片"
        prop="imageId"
        :label-width="formLabelWidth"
      >
        <el-row>
          <el-button type="primary" @click="openUpload">选择图片</el-button>
          <div v-if="form.imageId != ''" class="img">
            <img :src="filePath" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="分类排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading"
        >确 定</el-button
      >
    </div>
    <!--上传图片组件-->
    <Upload
      v-if="isupload"
      :isupload="isupload"
      :type="type"
      @returnImgs="returnImgsFunc"
      >上传图片</Upload
    >
  </el-dialog>
</template>

<script>
import materialApi from "@/api/material.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload,
  },
  data() {
    return {
      form: {
        categoryId: 0,
        parent_id: 0,
        name: "",
        imageId: "",
        sort: "",
      },
      filePath: "",
      formRules: {
        name: [
          {
            required: true,
            message: "请输入分类名称",
            trigger: "blur",
          },
        ],
        imageId: [
          {
            required: true,
            message: "请上传分类图片",
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: "分类排序不能为空",
          },
          {
            type: "number",
            message: "分类排序必须为数字",
          },
        ],
      },
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /*是否上传图片*/
      isupload: false,
    };
  },
  props: ["open_edit", "editform", "material_id"],
  created() {
    this.dialogVisible = this.open_edit;
    this.getdetail(this.material_id);
    // console.log(this.editform.model);
    // this.form.categoryId = this.material_id;
    // this.form.parent_id = this.editform.model.parent_id;
    // this.form.name = this.editform.model.name;
    // this.form.sort = this.editform.model.sort;
    // this.getImage(this.editform.model.categoryId);
  },
  methods: {
    getdetail(e) {
      let self = this;
      materialApi
        .catdetail(
          {
            material_id: e,
          },
          true
        )
        .then((res) => {
          console.log(res.data.detail)
          let form = res.data.detail;
          this.form.categoryId = form.material_id;
          this.form.name = form.name;
          this.form.sort = form.sort;
          this.form.imageId = form.imageId;
          this.filePath = form.image.filePath;
        });
    },
    /*修改用户*/
    addUser() {
      let self = this;
      let params = self.form;
      console.log(params)
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          materialApi
            .catEdit(params, true)
            .then((data) => {
              self.loading = false;
              self.$message({
                message: "修改成功",
                type: "success",
              });
              self.dialogFormVisible(true);
            })
            .catch((error) => {
              self.loading = false;
            });
        }
      });
    },
    getImage(categoryId) {
      PorductApi.cateImage(
        {
          categoryId: categoryId,
        },
        true
      )
        .then((data) => {
          this.form.imageId = data.data.detail.imageId;
          this.filePath = data.data.detail.image.filePath;
        })
        .catch((error) => {});
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false,
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false,
        });
      }
    },
    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.filePath = e[0].filePath;
        this.form.imageId = e[0].fileId;
      }
      this.isupload = false;
    },
  },
};
</script>

<style>
.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/materials/category/Edit.vue